import React from 'react';
import { Stack } from '@fluentui/react';
import { ActionContext } from '../../context/ActionContext';
import { CmicContext } from '../../context/CmicContext';
import AttachmentContainerUI from './AttachmentContainerUI';
import { THEME_ID, baseFontFamilyStyle } from './../../shared/styles';

const AttachmentContainer = () => {
	const { attachmentData } = React.useContext(ActionContext);
	const { currentOfficeTheme } = React.useContext(CmicContext);

	if (!attachmentData || attachmentData.length === 0) {
		return null;
	}

	const attachedUI = attachmentData.map((attachment, index) => {
		return <AttachmentContainerUI key={index} attachment={attachment} />;
	});

	return (
		<Stack
			id="userAttachmentBag"
			style={{ maxHeight: '10rem', overflowY: 'scroll', backgroundColor: currentOfficeTheme.bodyBackgroundColor }}
		>
			<Stack horizontal style={{ justifyContent: 'space-between', margin: '15px 3px' }}>
				<label
					style={{
						fontFamily: baseFontFamilyStyle,
						fontSize: '15px',
						fontWeight: '400',
						color:
							currentOfficeTheme.themeId === THEME_ID.BLACK ||
							currentOfficeTheme.themeId === THEME_ID.DARK_GREY
								? currentOfficeTheme.bodyForegroundColor
								: '#5E6367',
					}}
				>
					Attachments ({attachmentData.length})
				</label>
			</Stack>

			<div>
				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>{attachedUI}</div>
			</div>
			<div id="section-1"></div>
		</Stack>
	);
};

export default AttachmentContainer;
